import React from "react";
import EligibilityDetails from "../../eligibility/EligibilityDetails";
import { EligibilityDataComponent } from "../../../pages/HIS/CreateVisit";
import ListDetailsCard from "../../../shared/ListDetailsCard";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../utils/FormateDateTime";

function EligibilityDetailComp({ data }) {
  const { t } = useTranslation();
  const renderDetails = (item, index) => {
    const resource = item?.nphies_entries?.CoverageResp?.[0]?.resource;

    const eligibilityData = [
      { label: "Member Id", text: resource?.identifier?.[0]?.value },
      { label: "Coverage Type", text: resource?.type?.coding?.[0]?.display },
      {
        label: "Relationship",
        text: resource?.relationship?.coding?.[0]?.display,
      },
      { label: "Start Date", text: formatDate(resource?.period?.start) },
      { label: "End Date", text: formatDate(resource?.period?.end) },
      {
        label: "Company",
        text: resource?.class?.find(
          (c) => c.type?.coding?.[0]?.code === "group"
        )?.value,
      },
      {
        label: "Plan",
        text: resource?.class?.find((c) => c.type?.coding?.[0]?.code === "plan")
          ?.value,
      },
      {
        label: "Patient Share",
        text: resource?.costToBeneficiary?.find(
          (c) => c.type?.coding?.[0]?.code === "copaypct"
        )?.valueQuantity?.value,
      },
      {
        label: "Max Copay",
        text: resource?.costToBeneficiary?.find(
          (c) => c.type?.coding?.[0]?.code === "maxcopay"
        )?.valueMoney?.value,
      },
      { label: "Network", text: resource?.network },
    ];
    let disposition = item?.nphies_entries?.CovElgResp?.resource?.disposition;
    let siteEligibility =
      item?.nphies_entries?.CovElgResp?.resource?.extension?.[0]
        ?.valueCodeableConcept?.coding?.[0]?.code;

    return (
      <React.Fragment key={index}>
        <div className="flex items-center justify-start gap-2">
          {(disposition || siteEligibility) && <span>{index + 1} :</span>}
          <EligibilityDataComponent eligibilityData={item} />
        </div>
        {item?.nphies_status === "complete" && (
          <div className="mt-5">
            <ListDetailsCard listData={eligibilityData} />
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <>
      {Array.isArray(data) && data.length > 0
        ? data.map((item, index) => renderDetails(item, index))
        : data && renderDetails(data, 0)}
    </>
  );
}

export default EligibilityDetailComp;

// import React from 'react'
// import EligibilityDetails from '../../eligibility/EligibilityDetails'
// import { EligibilityDataComponent } from '../../../pages/HIS/CreateVisit'
// import ListDetailsCard from '../../../shared/ListDetailsCard'
// import { useTranslation } from 'react-i18next'
// import { formatDate } from '../../../utils/FormateDateTime'

// function EligibilityDetailComp ({ data }) {
//   const { t } = useTranslation()
//   const resource = data?.nphies_entries?.CoverageResp?.[0]?.resource

//   const memberId = resource?.identifier?.[0]?.value
//   const coverageType = resource?.type?.coding?.[0]?.display
//   const relationship = resource?.relationship?.coding?.[0]?.display
//   const startDate = resource?.period?.start
//   const endDate = resource?.period?.end
//   const company = resource?.class?.find(
//     c => c.type?.coding?.[0]?.code === 'group'
//   )?.value
//   const plan = resource?.class?.find(
//     c => c.type?.coding?.[0]?.code === 'plan'
//   )?.value
//   const patientShare = resource?.costToBeneficiary?.find(
//     c => c.type?.coding?.[0]?.code === 'copaypct'
//   )?.valueQuantity?.value
//   const maxCopay = resource?.costToBeneficiary?.find(
//     c => c.type?.coding?.[0]?.code === 'maxcopay'
//   )?.valueMoney?.value
//   const network = resource?.network
//   const eligigibiltyData = [
//     {
//       label: 'Member Id',
//       text: memberId
//     },
//     {
//       label: 'Coverage Type',
//       text: coverageType
//     },
//     {
//       label: 'Relationship',
//       text: relationship
//     },
//     {
//       label: 'Start Date',
//       text: formatDate(startDate)
//     },
//     {
//       label: 'End Date',
//       text: formatDate(endDate)
//     },
//     {
//       label: 'Company',
//       text: company
//     },
//     {
//       label: 'Plan',
//       text: plan
//     },
//     {
//       label: 'Patient Share',
//       text: patientShare
//     },
//     {
//       label: 'Max Copay',
//       text: maxCopay
//     },
//     {
//       label: 'Network',
//       text: network
//     }
//   ]

//   return (
//     <>
//       <EligibilityDataComponent eligibilityData={data} />

//       {data?.nphies_status === 'complete' && (
//         <div className='mt-5'>
//           <ListDetailsCard listData={eligigibiltyData} />
//         </div>
//       )}
//     </>
//   )
// }

// export default EligibilityDetailComp
